import { render, staticRenderFns } from "./fgtpwd_1.vue?vue&type=template&id=be3817a8&scoped=true&"
import script from "./fgtpwd_1.vue?vue&type=script&lang=js&"
export * from "./fgtpwd_1.vue?vue&type=script&lang=js&"
import style0 from "./fgtpwd_1.vue?vue&type=style&index=0&id=be3817a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3817a8",
  null
  
)

export default component.exports